module.exports = __webpack_public_path__ + "img/wave2.ad356e50.svg";